console.log("SCRIPT_LOAD: drawercart.js 20250509_0220_PM_EDT");

void 0 === Shopify && (window.Shopify = {}),
  void 0 === Shopify.getCart &&
    (Shopify.getCart = function (t, e) {
      if (!e)
        return jQuery.getJSON("/cart.js", function (e, a, r) {
          "function" == typeof t ? t(e, a, r) : Shopify.onCartUpdate(e);
        });
      "function" == typeof t
        ? t(e)
        : "function" == typeof Shopify.onCartUpdate && Shopify.onCartUpdate(e);
    });
var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (t, e) {
  if ("string" == typeof t) t = t.replace(".", "");
  var a = "",
    r = /\{\{\s*(\w+)\s*\}\}/,
    i = e || this.money_format;
  function o(t, e) {
    return void 0 === t ? e : t;
  }
  function n(t, e, a, r) {
    if (
      ((e = o(e, 2)), (a = o(a, ",")), (r = o(r, ".")), isNaN(t) || null == t)
    )
      return 0;
    var i = (t = (t / 100).toFixed(e)).split(".");
    return (
      i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
      (i[1] ? r + i[1] : "")
    );
  }
  switch (i.match(r)[1]) {
    case "amount":
      a = n(t, 2);
      break;
    case "amount_no_decimals":
      a = n(t, 0);
      break;
    case "amount_with_comma_separator":
      a = n(t, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      a = n(t, 0, ".", ",");
  }
  return i.replace(r, a);
};

class GoCart {
  constructor(t) {
    this.defaults = Object.assign(
      {},
      {
        cartModalFail: ".js-go-cart-modal-fail",
        cartModalFailClose: ".js-go-cart-modal-fail-close",
        cartModal: ".js-go-cart-modal",
        cartModalClose: ".js-go-cart-modal-close",
        cartModalContent: ".js-go-cart-modal-content",
        cartDrawer: ".js-go-cart-drawer",
        cartDrawerContent: ".js-go-cart-drawer-content",
        cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
        cartDrawerFooter: ".js-go-cart-drawer-footer",
        cartDrawerClose: ".js-go-cart-drawer-close",
        cartMiniCart: ".js-go-cart-mini-cart",
        cartMiniCartContent: ".js-go-cart-mini-cart-content",
        cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
        cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
        cartTrigger: ".js-go-cart-trigger",
        cartOverlay: ".js-go-cart-overlay",
        cartCount: ".js-go-cart-counter",
        addToCart: ".js-go-cart-add-to-cart",
        removeFromCart: ".js-go-cart-remove-from-cart",
        removeFromCartNoDot: "js-go-cart-remove-from-cart",
        itemQuantity: ".js-go-cart-quantity",
        itemQuantityPlus: ".js-go-cart-quantity-plus",
        itemQuantityMinus: ".js-go-cart-quantity-minus",
        cartMode: "drawer",
        drawerDirection: "right",
        displayModal: !1,
        moneyFormat: "${{amount}}",
        labelAddedToCart: "was added to your cart.",
        labelCartIsEmpty: "Your Cart is currently empty!",
        labelQuantity: "Quantity:",
        labelRemove: "Remove",
      },
      t
    );
    this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
    this.cartModalFailClose = document.querySelector(
      this.defaults.cartModalFailClose
    );
    this.cartModal = document.querySelector(this.defaults.cartModal);
    this.cartModalClose = document.querySelectorAll(
      this.defaults.cartModalClose
    );
    this.cartModalContent = document.querySelector(
      this.defaults.cartModalContent
    );
    this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
    this.cartDrawerContent = document.querySelector(
      this.defaults.cartDrawerContent
    );
    this.cartDrawerSubTotal = document.querySelector(
      this.defaults.cartDrawerSubTotal
    );
    this.cartDrawerFooter = document.querySelector(
      this.defaults.cartDrawerFooter
    );
    this.cartDrawerClose = document.querySelector(
      this.defaults.cartDrawerClose
    );
    this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
    this.cartMiniCartContent = document.querySelector(
      this.defaults.cartMiniCartContent
    );
    this.cartMiniCartSubTotal = document.querySelector(
      this.defaults.cartMiniCartSubTotal
    );
    this.cartMiniCartFooter = document.querySelector(
      this.defaults.cartMiniCartFooter
    );
    this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
    this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
    this.cartCount = document.querySelector(this.defaults.cartCount);
    this.addToCart = document.querySelectorAll(this.defaults.addToCart);
    this.removeFromCart = this.defaults.removeFromCart;
    this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
    this.itemQuantity = this.defaults.itemQuantity;
    this.itemQuantityPlus = this.defaults.itemQuantityPlus;
    this.itemQuantityMinus = this.defaults.itemQuantityMinus;
    this.cartMode = this.defaults.cartMode;
    this.drawerDirection = this.defaults.drawerDirection;
    this.displayModal = this.defaults.displayModal;
    this.moneyFormat = this.defaults.moneyFormat;
    this.labelAddedToCart = this.defaults.labelAddedToCart;
    this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
    this.labelQuantity = this.defaults.labelQuantity;
    this.labelRemove = this.defaults.labelRemove;
    this.init();
  }

  get isDrawerMode() {
    return this.cartMode === "drawer";
  }

  init() {
    this.fetchCart();

    if (this.isDrawerMode) {
      this.setDrawerDirection();
    } else {
      document.querySelector(".go-cart-wrp").classList.add("mini-cart");
    }

    // ** Add to Cart listener **
    document.addEventListener(
      "click",
      (evt) => {
        if (evt.target.matches(this.defaults.addToCart)) {
          evt.preventDefault();
          let form = evt.target;
          while (form.tagName.toLowerCase() !== "form") {
            form = form.parentNode;
          }
          const formId = form.getAttribute("id");
          const qty = parseInt(
            document.querySelector('input[name="quantity"]').value,
            10
          );
          const available = parseInt(
            document.querySelector(".inventoryNote").textContent,
            10
          );
          if (!available || qty <= available) {
            this.addItemToCart(formId);
          }
        }
      },
      false
    );

    // ** Hover to trigger cart drawer/mini-cart **
    this.cartTrigger.forEach((btn) => {
      btn.addEventListener("mouseover", () => {
        this.isDrawerMode ? this.openCartDrawer() : this.openMiniCart();
        this.openCartOverlay();
      });
    });

    // ** Overlay click to close cart **
    this.cartOverlay.addEventListener("click", () => {
      this.closeCartModal();
      this.isDrawerMode ? this.closeCartDrawer() : this.closeMiniCart();
      this.closeCartOverlay();
    });

    if (this.isDrawerMode && this.cartDrawerClose) {
      this.cartDrawerClose.addEventListener("click", () => {
        this.closeCartDrawer();
        this.closeCartOverlay();
      });
    }

    if (this.displayModal) {
      this.cartModalClose.forEach((el) => {
        el.addEventListener("click", () => {
          this.closeCartModal();
          this.isDrawerMode ? this.closeCartDrawer() : this.closeMiniCart();
          this.closeCartOverlay();
        });
      });
    }

    if (this.cartModalFailClose) {
      this.cartModalFailClose.addEventListener("click", () => {
        this.closeCartModal();
        this.isDrawerMode ? this.closeCartDrawer() : this.closeMiniCart();
        this.closeCartOverlay();
      });
    }
  }

  fetchCart(callback) {
    fetch("/cart.js", { credentials: "same-origin", method: "GET" })
      .then((r) => r.json())
      .then((cart) => this.fetchHandler(cart, callback))
      .catch((err) => {
        this.ajaxRequestFail();
        throw err;
      });
  }

  // ** Handle Add to Cart **
  addItemToCart(formId) {
    if (document.querySelectorAll('button[name="add"]').length > 0) {
      document.querySelector('button[name="add"]').classList.add("adding");
    }
    Shopify.getCart(
      function () {
        const form = document.querySelector(`#${formId}`);
        setTimeout(() => {
          fetch("/cart/add.js", {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(new FormData(form)).toString(),
          })
            .then((r) => r.json())
            .then(() => {
              jQuery.getJSON("/cart.js", (t) => {
                let freeLine = 0;
                t.items.forEach((it) => {
                  const name = it.product_title;
                  if (
                    name !== "Free Gift w/ Purchase" &&
                    name.toLowerCase().startsWith("free")
                  ) {
                    freeLine = it.line_price;
                  }
                });
                if (freeLine > 0) {
                  jQuery(".FreeProductGridContainer .preview-card").each(
                    function () {
                      jQuery(this).find(".form").remove();
                      jQuery(this).append(
                        '<button class="btn_disable btn_full" style="margin-top: 16px;" disabled="">UNAVAILABLE - FREE PRODUCT ALREADY IN CART</button>'
                      );
                      jQuery(
                        ".FreeProductGridContainer .preview-card"
                      ).removeClass("open");
                    }
                  );
                }
              });
            })
            .then((t) => this.addItemToCartHandler(t))
            .catch((err) => {
              this.ajaxRequestFail();
              throw err;
            })
            .finally(() => {
              if (document.querySelectorAll('button[name="add"]').length > 0) {
                document
                  .querySelector('button[name="add"]')
                  .classList.remove("adding");
              }
            });
        }, 2000);
      }.bind(this)
    );
  }

  removeItem(line) {
    Shopify.getCart(
      function () {
        fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: line, quantity: 0 }),
        })
          .then((r) => r.json())
          .then(() => this.fetchCart())
          .catch((err) => {
            this.ajaxRequestFail();
            throw err;
          });
      }.bind(this)
    );
  }

  changeItemQuantity(line, qty) {
    Shopify.getCart(
      function () {
        fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: line, quantity: qty }),
        })
          .then((r) => r.json())
          .then(() => this.fetchCart())
          .catch((err) => {
            this.ajaxRequestFail();
            throw err;
          });
      }.bind(this)
    );
  }

  cartItemCount(cart) {
    document.querySelectorAll(".js-go-cart-counter").forEach((el) => {
      el.innerHTML = cart.item_count;
    });
  }

  fetchAndOpenCart() {
    this.fetchCart(() => {
      this.isDrawerMode ? this.openCartDrawer() : this.openMiniCart();
      this.openCartOverlay();
    });
  }

  fetchAndOpenModal(item) {
    this.fetchCart(() => {
      this.renderCartModal(item);
      this.openCartModal();
      this.openCartOverlay();
    });
  }

  // ** Handle Cart Rendering and Subtotal Updates **
  fetchHandler(cart, callback) {
    this.cartItemCount(cart);

    if (this.isDrawerMode) {
      if (cart.item_count === 0) {
        this.renderBlankCartDrawer();
        this.cartDrawerFooter.classList.add("is-invisible");
      } else {
        this.renderDrawerCart(cart);
        this.cartDrawerFooter.classList.remove("is-invisible");
        if (typeof callback === "function") callback(cart);
      }
    } else {
      if (cart.item_count === 0) {
        this.renderBlankMiniCart();
        this.cartMiniCartFooter.classList.add("is-invisible");
      } else {
        this.renderMiniCart(cart);
        this.cartMiniCartFooter.classList.remove("is-invisible");
        if (typeof callback === "function") callback(cart);
      }
    }
  }

  addItemToCartHandler(item) {
    if (this.displayModal) {
      this.fetchAndOpenModal(item);
    } else {
      this.fetchAndOpenCart();
    }
  }

  ajaxRequestFail() {}

  renderCartModal(item) {
    this.clearCartModal();
    const variantText = item.variant_title ? `(${item.variant_title})` : "";
    const imgUrl = item.image || "";
    this.cartModalContent.innerHTML += `
      <div class="go-cart-modal-item">
        <div class="go-cart-item__image" style="background-image:url(${imgUrl});"></div>
        <div class="go-cart-item__info">
          <a href="${item.url}" class="go-cart-item__title">
            ${item.product_title} ${variantText}
          </a> ${this.labelAddedToCart}
        </div>
      </div>`;
  }

  renderDrawerCart(cart) {
    this.clearCartDrawer();

    cart.items.forEach((item, index) => {
      // ——— 1) compute prices ———
      const currentLinePriceCents = item.line_price;
      const originalLinePriceCents = item.original_price * item.quantity;
      const formattedCurrent = Shopify.formatMoney(
        currentLinePriceCents,
        this.moneyFormat
      );
      const formattedOriginal = Shopify.formatMoney(
        originalLinePriceCents,
        this.moneyFormat
      );
      const showOriginal = originalLinePriceCents > currentLinePriceCents;

      // ——— 2) free‑gift logic ———
      const title = item.product_title;
      const variantTitle = item.variant_title || "";
      const isFree = title.toLowerCase().startsWith("free");

      // ——— 3) image resizing ———
      const rawImg = item.image || "";
      const imgUrl = rawImg.replace(/(\.png|\.jpe?g|\.webp)$/, `_200x320$1`);

      // ——— 4) build price+quantity HTML ———
      let priceQuantityHtml;
      if (isFree) {
        priceQuantityHtml = `
          <div class="go-cart-item__price h5 m0">FREE</div>
        `;
      } else {
        priceQuantityHtml = `
          ${
            showOriginal
              ? `<div class="go-cart-item__price--original h6 m0"><s>${formattedOriginal}</s></div>`
              : ""
          }
          <div class="go-cart-item__price h5 m0">${formattedCurrent}</div>
          <div class="go-cart-item__quantity">
            <span class="go-cart-item__quantity-label">${
              this.labelQuantity
            }</span>
            <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
            <input class="go-cart-item__quantity-number js-go-cart-quantity"
                   type="number"
                   data-quantityid="${item.id}"
                   value="${item.quantity}"
                   disabled>
            <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
          </div>
        `;
      }

      // ——— 5) assemble full item HTML ———
      const itemHtml = `
        <div class="go-cart-item__single" data-line="${index + 1}" data-id="${
        item.id
      }" data-handle="${item.handle}">
          <div class="go-cart-item__info-wrapper">
            <div class="go-cart-item__image" style="background-image:url(${imgUrl});"></div>
            <div class="go-cart-item__info">
              <div class="go-cart-item__wrp">
                ${
                  isFree
                    ? `<span class="go-cart-item__title_free fw_600 h6 mt0 mb10">${title}</span>`
                    : `<a href="${item.url}" class="go-cart-item__title fw_600 h6 mt0 mb10">${title}</a>`
                }
                ${
                  variantTitle
                    ? `<div class="go-cart-item__variant fw_600 caps mt0 mb10">${variantTitle}</div>`
                    : ""
                }
                <div class="remove-link fw_600 caps mt26">
                  <span class="js-go-cart-remove-from-cart">${
                    this.labelRemove
                  }</span>
                </div>
              </div>
              <div class="quantity-wrp mb10">
                ${priceQuantityHtml}
              </div>
            </div>
          </div>
        </div>`;
      this.cartDrawerContent.innerHTML += itemHtml;
    });

    // ——— 6) update subtotal ———
    let freeAmount = 0;
    cart.items.forEach((item) => {
      if (item.product_title.toLowerCase().startsWith("free")) {
        freeAmount += item.line_price;
      }
    });
    const subtotal = cart.total_price - freeAmount;
    this.cartDrawerSubTotal.innerHTML = Shopify.formatMoney(
      subtotal,
      this.moneyFormat
    );
    this.cartDrawerSubTotal.parentNode.classList.remove("is-invisible");

    // ——— 7) re‑bind buttons ———
    document.querySelectorAll(this.removeFromCart).forEach((el) => {
      el.addEventListener("click", () => {
        const line = el
          .closest(".go-cart-item__single")
          .getAttribute("data-line");
        GoCart.removeItemAnimation(el.closest(".go-cart-item__single"));
        this.removeItem(line);
      });
    });
    document.querySelectorAll(this.itemQuantityPlus).forEach((el) => {
      el.addEventListener("click", () => {
        const line = el
          .closest(".go-cart-item__single")
          .getAttribute("data-line");
        const qty =
          Number(
            el.closest(".go-cart-item__single").querySelector(this.itemQuantity)
              .value
          ) + 1;
        this.changeItemQuantity(line, qty);
      });
    });
    document.querySelectorAll(this.itemQuantityMinus).forEach((el) => {
      el.addEventListener("click", () => {
        const wrapper = el.closest(".go-cart-item__single");
        const line = wrapper.getAttribute("data-line");
        const qty = Number(wrapper.querySelector(this.itemQuantity).value) - 1;
        if (qty <= 0) GoCart.removeItemAnimation(wrapper);
        this.changeItemQuantity(line, qty);
      });
    });

    // ——— 8) tag‑based UI tweaks ———
    getTagFirstMonthFree();
  }

  renderMiniCart(cart) {
    this.clearMiniCart();
    cart.items.forEach((item, index) => {
      const formattedLine = Shopify.formatMoney(
        item.line_price,
        this.moneyFormat
      );
      this.cartMiniCartContent.innerHTML += `
        <div class="go-cart-item__single" data-line="${index + 1}" data-id="${
        item.id
      }">
          <div class="go-cart-item__info-wrapper">
            <div class="go-cart-item__image" style="background-image:url(${
              item.image
            });"></div>
            <div class="go-cart-item__info">
              <a href="${item.url}" class="go-cart-item__title">${
        item.product_title
      }</a>
              <div class="go-cart-item__price">${formattedLine}</div>
              <div class="go-cart-item__quantity">
                <span class="go-cart-item__quantity-label">${
                  this.labelQuantity
                }</span>
                <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                <input class="go-cart-item__quantity-number js-go-cart-quantity"
                       type="number"
                       data-quantityid="${item.id}"
                       value="${item.quantity}"
                       disabled>
                <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
              </div>
            </div>
            <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${
        this.labelRemove
      }</a>
          </div>
        </div>`;
    });
    this.cartMiniCartSubTotal.innerHTML = Shopify.formatMoney(
      cart.total_price,
      this.moneyFormat
    );
    this.cartMiniCartSubTotal.parentNode.classList.remove("is-invisible");

    document.querySelectorAll(this.removeFromCart).forEach((el) => {
      el.addEventListener("click", () => {
        const line = el
          .closest(".go-cart-item__single")
          .getAttribute("data-line");
        GoCart.removeItemAnimation(el.closest(".go-cart-item__single"));
        this.removeItem(line);
      });
    });
    document.querySelectorAll(this.itemQuantityPlus).forEach((el) => {
      el.addEventListener("click", () => {
        const line = el
          .closest(".go-cart-item__single")
          .getAttribute("data-line");
        const qty =
          Number(
            el.closest(".go-cart-item__single").querySelector(this.itemQuantity)
              .value
          ) + 1;
        this.changeItemQuantity(line, qty);
      });
    });
    document.querySelectorAll(this.itemQuantityMinus).forEach((el) => {
      el.addEventListener("click", () => {
        const line = el
          .closest(".go-cart-item__single")
          .getAttribute("data-line");
        const qty =
          Number(
            el.closest(".go-cart-item__single").querySelector(this.itemQuantity)
              .value
          ) - 1;
        this.changeItemQuantity(line, qty);
        if (qty <= 0)
          GoCart.removeItemAnimation(el.closest(".go-cart-item__single"));
      });
    });
  }

  renderBlankCartDrawer() {
    this.cartDrawerSubTotal.parentNode.classList.add("is-invisible");
    this.clearCartDrawer();
    this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
  }

  renderBlankMiniCart() {
    this.cartMiniCartSubTotal.parentNode.classList.add("is-invisible");
    this.clearMiniCart();
    this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
  }

  clearCartDrawer() {
    this.cartDrawerContent.innerHTML = "";
  }

  clearMiniCart() {
    this.cartMiniCartContent.innerHTML = "";
  }

  clearCartModal() {
    this.cartModalContent.innerHTML = "";
  }

  openCartDrawer() {
    this.cartDrawer.classList.add("is-open");
    document.body.classList.add("overflow-hidden");
  }

  closeCartDrawer() {
    this.cartDrawer.classList.remove("is-open");
    document.body.classList.remove("overflow-hidden");
  }

  openMiniCart() {
    this.cartMiniCart.classList.add("is-open");
  }

  closeMiniCart() {
    this.cartMiniCart.classList.remove("is-open");
  }

  openCartModal() {
    this.cartModal.classList.add("is-open");
  }

  closeCartModal() {
    this.cartModal.classList.remove("is-open");
  }

  openCartOverlay() {
    this.cartOverlay.classList.add("is-open");
  }

  closeCartOverlay() {
    this.cartOverlay.classList.remove("is-open");
  }

  static removeItemAnimation(el) {
    el.classList.add("is-invisible");
  }

  setDrawerDirection() {
    this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
  }
}

// Mini-cart close
document
  .querySelector(".js-go-cart-mini-cart-close")
  .addEventListener("click", function () {
    setTimeout(() => {
      document
        .querySelector(".js-go-cart-mini-cart")
        .classList.remove("is-open");
      document.querySelector(".js-go-cart-overlay").classList.remove("is-open");
    }, 100);
  });

var goCart = new GoCart({ cartMode: "drawer" });

function getTagFirstMonthFree() {
  setTimeout(() => {
    document.querySelectorAll(".go-cart-item__single").forEach((el) => {
      if (first_month_free.includes(el.dataset.handle)) {
        el.querySelector(".go-cart-item__wrp").classList.add("mc-fmf");
      }
      if (limit_1_per_order.includes(el.dataset.handle)) {
        el.querySelectorAll(".go-cart-item__quantity").forEach((q) =>
          q.classList.add("d-none")
        );
      }
      if (no_qty_adjust.includes(el.dataset.handle)) {
        el.querySelectorAll(".go-cart-item__quantity").forEach((q) =>
          q.classList.add("d-none")
        );
      }
    });
  }, 50);
}

if (goCart.cartMode === "mini-cart") {
  document.querySelector(".js-go-cart-mini-cart").classList.remove("hidden");
}
getTagFirstMonthFree();
